import { updateSubmission } from 'api/submission';
import { EMAIL_REGX, genericErrorMessage, META } from 'common/constants';
import { displayToastMessage } from 'components/ToastMessage';
import { useFormik } from 'formik';
import { type FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { EligibilityStepPropsBase } from 'routes/Eligibility/Eligibility.types';
import * as yup from 'yup';
import { EligibilityResultWrapper } from '../../components/EligibilityResultWrapper';
import type { EligibilityFailedFormValues } from './EligibilityFailed.types';

const validationSchema = yup.object({
  email: yup.string().matches(EMAIL_REGX, 'Invalid email format').required(),
});

const CheckEligibilityFailed: FC<EligibilityStepPropsBase> = ({ failMessage }) => {
  const { id: submissionId } = useParams<{ id: string }>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik<EligibilityFailedFormValues>({
    initialValues: {
      email: '',
      subscribeOnMailing: false,
    },
    validationSchema,
    onSubmit: async (values: EligibilityFailedFormValues) => {
      if (formik.isValid) {
        try {
          setIsSubmitting(true);

          await updateSubmission({
            id: submissionId!,
            email: values.email,
            subscribe_to_news: values.subscribeOnMailing,
          });

          // redirect to THREE homepage without waiting for the response
          window.location.href = META.HOME_LINK;
        } catch (_error) {
          displayToastMessage('ERROR', genericErrorMessage);
          setIsSubmitting(false);
        }
      }
    },
  });

  return (
    <EligibilityResultWrapper
      actionButtonText="Submit"
      formDisabled={isSubmitting}
      formik={formik}
      result="failed"
      {...failMessage!}
    />
  );
};

export default CheckEligibilityFailed;
